import general_messages from 'messages/general_messages';

const booleanDictionary = [
  { id: 'true', name: general_messages.yes },
  { id: 'false', name: general_messages.no },
];

export default booleanDictionary;
